import { render, staticRenderFns } from "./index.vue?vue&type=template&id=32ceee97&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=32ceee97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ceee97",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32ceee97')) {
      api.createRecord('32ceee97', component.options)
    } else {
      api.reload('32ceee97', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=32ceee97&scoped=true&", function () {
      api.rerender('32ceee97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/business/BSelectWindows/index.vue"
export default component.exports